import React from 'react'
import PropTypes from 'prop-types'
import useAuthority from 'utils/hooks/useAuthority'
import {useDispatch, useSelector} from "react-redux";
import {setFirstRoute} from "../../store/base/commonSlice";

const AuthorityCheck = props => {
	const firstRoute = useSelector((state) => state.base.common.firstRoute);
	const dispatch = useDispatch()

	const { userAuthority = [], authority = [], children, data } = props

	const roleMatched = useAuthority(userAuthority, authority)

	if (roleMatched && !firstRoute?.key) {
		dispatch(setFirstRoute(data))
	}

	return roleMatched ? children : <></>
}

AuthorityCheck.propTypes = {
	userAuthority: PropTypes.array,
	authority: PropTypes.array,
}

export default AuthorityCheck